module.exports = __webpack_public_path__ + "static/media/sologo.01cd6b81.png";